<script setup lang="ts">
</script>

<template>
  <section class="container pt-[53px] mx-auto px-4">
    <AnimateOnScroll animation="zoom-in">
      <h2 class="text-3xl! sm:text-[32px]! leading-11! text-center font-semibold text-neutral-800">
        Rintisan telah Membantu banyak UKM dan
        <br class="hidden md:block">
        Perusahaan mengatur Cashflow Bisnis mereka.
        <br class="hidden md:block">
        Jadi
        <span class="text-white bg-gradient-rintisan px-[10px] py-[4px] rounded-md">#MakinRingan</span>
        bersama Rintisan Billing
      </h2>
    </AnimateOnScroll>
  </section>
</template>
